const componentStyles = (theme) => ({
  bgDefault: {
    backgroundColor: "#211c61",
  },
});

export default componentStyles;
